// extracted by mini-css-extract-plugin
export default {"opacity":"dnd-images-list_opacity__IJSi6","imageContainer":"dnd-images-list_imageContainer__JHTh1"};